const QUESTION_TYPES = require('../lib/question_types');
const html = require('choo/html');

const questions = [
  {
    id: '01',
    type: QUESTION_TYPES.MULTISELECT_MULTIPLE_CHOICE,
    singleAnswer: true,
    question: html`
      <div>
        <div>
          Which case did federal prosecutors treat as domestic terrorism?
        </div>
      </div>
    `,
    choices: [
      'Warren Aubra Taylor, an anti-government extremist whose nickname was “Gator,” took hostages and engaged in an armed standoff at a post office.',
      'Taylor Michael Wilson, a white supremacist, pulled the emergency brake on an Amtrak train as part of an attempt to attack black passengers.',
      'Robert J. Goldstein, a podiatrist, and Michael Hardee, a dentist, plotted together to bomb a mosque.'
    ],
    answer: '1',
    explanation:
      'Attacking a mass transit system is one of the very few ways to guarantee prosecution as a domestic terrorist. Since 9/11, prosecutors have charged two defendants, including Taylor Michael Wilson, under a law that defines attacks on mass transit systems as terrorism.'
  },
  {
    id: '02',
    type: QUESTION_TYPES.MULTISELECT_MULTIPLE_CHOICE,
    singleAnswer: false,
    question: html`
      <div>
        Prosecutors filed terrorism charges against which defendants?
        <div>(Select as many as you think apply.)</div>
      </div>
    `,
    choices: [
      'James Alex Fields Jr., a white supremacist who attended the 2017 “Unite the Right” rally in Charlottesville, Virginia, drove his car into a crowd of people, killing 32-year-old Heather Heyer.',
      'Sayfullo Saipov, an ISIS supporter, allegedly drove a rented truck through a Manhattan bike lane in 2017, killing eight people.',
      'Dylann Roof, who had written a manifesto advocating for racial segregation in the U.S., shot and killed nine black worshippers in a South Carolina church in 2015.',
      'Noor Salman was the wife of avowed ISIS supporter Omar Mateen, who shot and killed 49 people at Pulse nightclub in Orlando in 2016.'
    ],
    answer: '1,3',
    explanation:
      'Saipov and Salman, both Muslims allegedly linked to a foreign terrorist group, were charged with terrorism. Saipov faces the death penalty if convicted. Salman was acquitted at trial. Roof was sentenced to death. A state court judge sentenced Fields to life in prison for murder; his trial in U.S. District Court has not yet been scheduled.'
  },
  {
    id: '03',
    type: QUESTION_TYPES.MULTIPLE_CHOICE,
    question: html`
      <div>
        It is illegal to provide material support to a designated
        terrorist organization. Giving money to which of these groups
        could result in criminal prosecution?
      </div>
    `,
    choices: [
      'Army of God',
      'Army of Islam',
      'Atomwaffen Division',
    ],
    answer: 1,
    explanation: html`
      <div>
        The Army of Islam is the only U.S.-designated terrorist organization on
        this list. No law prohibits financial support for domestic extremist
        groups, such as the Army of God, an anti-abortion group, or Atomwaffen
        Division, a violent neo-Nazi group.
      </div>
    `
  },
  {
    id: '04',
    type: QUESTION_TYPES.YES_NO,
    question: html`
      <div>
        Joseph Buddenberg and Nicole Kissane vandalized commercial animal farms
        and released a total of 5,700 captive mink from farms throughout the
        country. They also set loose a bobcat from a farm in Montana. Were they
        charged with a terrorism-related offense?
      </div>
    `,
    answer: 1,
    explanation: html`
      <div>
        Yes. Despite the fact that no one was harmed, Buddenberg and Kissane were charged
        and convicted under the Animal Enterprise Terrorism Act, a controversial
        law that prohibits activities committed “for the purpose of damaging or
        interfering with the operations of an animal enterprise.”
      </div>
    `
  },
  {
    id: '05',
    type: QUESTION_TYPES.MULTIPLE_CHOICE,
    question: html`
      <div>
        <div>
          Justin Carl Moose, a member of the anti-abortion group Army of God,
          described himself as the “Christian counterpart of Osama bin Laden.”
          As part of a sting, an FBI informant collaborated with Moose on a plan to bomb
          a women’s clinic in North Carolina. Moose pleaded guilty to an explosive
          charges.
        </div>
        <div>How much prison time did Moose receive?</div>
      </div>
    `,
    choices: ['30 months', '10 years', '30 years'],
    answer: 0,
    explanation: html`
      <div>
        Justin Carl Moose spent 30 months in prison for his crime. Compare that
        to the case of Harlem Suarez, an ISIS supporter who collaborated with an
        FBI informant and undercover agents on a bomb plot in Florida and was
        sentenced to life in prison.
      </div>
    `
  },
  {
    id: '06',
    type: QUESTION_TYPES.MULTISELECT_MULTIPLE_CHOICE,
    singleAnswer: false,
    question: html`
      <div>
        Which of these domestic extremists have been released
        from prison?
        <div>(Select as many as you think apply.)</div>
      </div>
    `,
    choices: [
      'Donny Eugene Mower threw a brick at a mosque and a Molotov cocktail into a women\'s clinic in California in 2010. Notes from Mower referenced a group called "American Nationalist Brotherhood."',
      'James D. Brailey, a white supremacist and member of the anti-government Jural Society, plotted to kill Washington state Gov. Gary Locke until his arrest in January 2003.',
      'Michael Lee Fullmore wanted to create a more violent subgroup of the Ku Klux Klan. Fullmore told an FBI informant in 2013 that he was planning to bomb a Catholic church in Georgia because of its ties to the Latino community.',
      'Gabriel Carafa, a white supremacist skinhead, asked a police informant for help building a bomb to kill minorities. In April 2005, Carafa purchased 60 pounds of fertilizer to use in the bomb.'
    ],
    answer: '0,1,2,3',
    explanation: html`
      <div>
        All four have been released from prison. The median sentence for crimes
        that appear to have met the definition of domestic terrorism since 9/11 was six years,
        according to The Intercept’s analysis. Mower was sentenced to 60 months
        in prison, Brailey to 15 months, Fullmore to 52 months, and Carafa to 80
        months.
      </div>
    `
  },
  {
    id: '07',
    type: QUESTION_TYPES.MULTISELECT_MULTIPLE_CHOICE,
    singleAnswer: true,
    question: html`
      <div>
        Which defendant did federal prosecutors treat as a domestic terrorist?
      </div>
    `,
    choices: [
      'Michael Christopher Estes placed a bomb at the Asheville Regional Airport in North Carolina in October 2017. He told law enforcement officials that he was getting ready to “fight a war on U.S. soil.”',
      'Michael Emry tried to deliver a stolen machine gun to the anti-government protesters occupying the Malheur National Wildlife Refuge in Oregon in January 2016.',
      'Bernandino Bolatete shared Islamophobic material online and told a police informant that he wanted to attack a mosque in Florida. An undercover police officer sold Bolatete a silencer to use in the planned attack in December 2017.',
      'None of the above.'
    ],
    answer: '3',
    explanation:
      'None of these alleged crimes were prosecuted under federal terrorism statues. Estes was charged with and convicted of possessing explosives, while Emry and Bolatete were charged with and convicted of firearms violations.'
  },
  {
    id: '08',
    type: QUESTION_TYPES.MULTIPLE_CHOICE,
    question: html`
      <div>
        <div>
          Which group has the FBI described as “the No. 1 domestic terrorism
          threat”?
        </div>
      </div>
    `,
    choices: [
      'White supremacists',
      'Sovereign citizens',
      'Environmental extremists',
      'Anti-abortion extremists'
    ],
    answer: 2,
    explanation: html`
      <div>
        <div>
          After the 9/11 attacks, the FBI described environmental extremists, or
          "eco-terrorists" in government parlance, as the nation's primary
          domestic terrorism threat. The FBI continued to make that claim
          publicly until at least 2008. No one in the U.S. has ever been killed in an arson
          or act of vandalism committed by radical environmentalists
        </div>
      </div>
    `
  }
];

module.exports = questions;
